'use strict';

wbApp.directive('wbRecipientList', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        replace: true,
        scope: {
            ngModel: '=',
            wbAutoSize: '='
        },
        template:
            '<div class="btn-toolbar" style="padding: 0px 0px; overflow-y: auto; overflow-x: hidden; max-height: 32px;" ng-style="{display: wbAutoSize ? \'table-cell\' : \'inline-block\'}" >' +
                '<div class="btn-group" ng-repeat="item in ngModel" style="margin: 4px;">' +
                    '<button class="btn btn-default btn-xs">{{item.name}}</button>' +
                    '<button class="btn btn-default btn-xs" ng-click="removeItem(item)">' +
                        '<span class="glyphicon glyphicon-remove"></span>' +
                    '</button>' +
                '</div>' +
            '<div>',
        link: function (scope, element, attr, ctrl) {
            scope.removeItem = function (item) {
                if (!scope.ngModel || !item) {
                    return;
                }

                var idx = scope.ngModel.indexOf(item);
                if (idx !== -1) {
                    scope.ngModel.splice(idx, 1);
                }
            }
        }
    }
});